module.exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " ~ ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " \uC120\uD0DD\uB428");
  },
  "finishRangeSelectionPrompt": "\uB0A0\uC9DC \uBC94\uC704 \uC120\uD0DD\uC744 \uC644\uB8CC\uD558\uB824\uBA74 \uD074\uB9AD\uD558\uC2ED\uC2DC\uC624.",
  "maximumDate": "\uB9C8\uC9C0\uB9C9\uC73C\uB85C \uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uC77C\uC790",
  "minimumDate": "\uCC98\uC74C\uC73C\uB85C \uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uC77C\uC790",
  "next": "\uB2E4\uC74C",
  "previous": "\uC774\uC804",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "\uC120\uD0DD \uC77C\uC790: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "\uC120\uD0DD \uBC94\uC704: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "\uB0A0\uC9DC \uBC94\uC704 \uC120\uD0DD\uC744 \uC2DC\uC791\uD558\uB824\uBA74 \uD074\uB9AD\uD558\uC2ED\uC2DC\uC624.",
  "todayDate": function todayDate(args) {
    return "\uC624\uB298, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "\uC624\uB298, ".concat(args.date, " \uC120\uD0DD\uB428");
  }
};